import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch catering area charges (delivery charges by area)
 * @param {string} countryId - Country ID (default: "3" for Kuwait)
 * @returns {Promise<Object>} - Response data from the API
 */
export const getCateringAreaCharges = async (countryId = "3") => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.CATERING_AREA_CHARGES}?country_id=${countryId}`
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

